// extracted by mini-css-extract-plugin
export default {"active-players":"active-players_active-players__jsCjm"};